import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui-kit/dropdown-menu';
import { Button } from '@/components/ui-kit/button';
import { EllipsisVertical } from 'lucide-react';
import { IModelInfo } from '@/modules/gpt-chats/types/aimodel.service.type';

type AIModelRowActionsDropdownProps = {
  model: IModelInfo;
  onEdit: (model: IModelInfo) => void;
  onDelete: (model: IModelInfo) => void;
  onOpenChange?: (open: boolean) => void;
};

import { useTranslation } from 'react-i18next';

export const AIModelRowActionsDropdown = ({
  model,
  onEdit,
  onDelete,
  onOpenChange,
}: AIModelRowActionsDropdownProps) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        {/* Ellipsis only visible on row hover (via .group on the row) */}
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 rounded-full p-0"
          onClick={(e) => e.stopPropagation()}
        >
          <EllipsisVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            onEdit(model);
          }}
        >
          {t('EDIT')}
        </DropdownMenuItem>

        <DropdownMenuItem
          className="!text-error"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(model);
          }}
        >
          {t('DELETE')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
